import * as MutationTypes from './mutationTypes';
import * as api from './api';
import { Feature, Tag } from './models';

export const masterFeatureListRequest = async ({ commit, getters: { masterFeatureList } }) => {
  if (masterFeatureList.length === 0) {
    const response = await api.getMasterFeatureListRequest();
    const features = Feature.toInstanceList(response.data.results);
    commit(MutationTypes.MASTER_FEATURE_LIST_SUCCESS, features);
  }
};

export const masterTagsListRequest = async ({ commit, getters: { masterTagList } }) => {
  if (masterTagList.length === 0) {
    const response = await api.getMasterTagsListRequest();
    const tags = Tag.toInstanceList(response.data.results);
    commit(MutationTypes.MASTER_TAG_LIST_SUCCESS, tags);
  }
};
